import request from "@/utils/request";

/**
 * 获取数据源列表
 * @returns 
 */
export function getSourceList(fleetCompanyId) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/eld-integration/getSourceList`,
    method: "get",
    params: {
      fleetCompanyId: fleetCompanyId
    },
    headers: {
      "portal-token": true,
    }
  })
}

/**
 * 集成账号
 * @param {*} data 
 * @returns 
 */
export function integrationAccount(data) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: "/zuul/eld-integration/integrationAccount",
    method: "post",
    data,
    headers: {
      "portal-token": true,
    }
  })
}

/**
 * 解绑账号
 * @param {*} id  fleetCompanyId
 * @returns 
 */
export function unbindIntegrationAccount(id, params) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/eld-integration/de-authorize/${id}`,
    method: "get",
    params,
    headers: {
      "portal-token": true,
    }
  })
}

/**
 * 点击To connect页拉取 Driver
 * @returns 
 */
export function integrationDriver(fleetCompanyId) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/eld-integration/integrationAllDriver`,
    method: "get",
    params: {
      fleetCompanyId: fleetCompanyId
    },
    headers: {
      "portal-token": true,
    }
  })
}

/**
 * 集成账号时拉取 Driver
 * @param {*} data 
 * @returns 
 */
 export function integrationDriver2(id) {
  return request({
    url: `/fleet/eld-integration/integrationDriver/${id}`,
    method: "get",
    headers: {
      "portal-token": true,
    }
  })
}

/**
 * 点击To connect页拉取 Truck
 * @returns 
 */
export function integrationTruck(fleetCompanyId) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/eld-integration/integrationAllTruck`,
    method: "get",
    params: {
      fleetCompanyId: fleetCompanyId
    },
    headers: {
      "portal-token": true,
    }
  })
}

/**
 * 集成账号时拉取 Truck
 * @param {*} id 
 * @returns 
 */
export function integrationTruck2(id) {
  return request({
    url: `/fleet/eld-integration/integrationTruck/${id}`,
    method: "",
    headers: {
      "portal-token": true,
    }
  })
}

/**
 * 获取上次更新时间
 * @param {*} type driver || truck || location
 * @returns 
 */
 export function getLastUpdateTime(type, fleetCompanyId) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/eld-integration/last/update/${type}`,
    method: "get",
    params: {
      fleetCompanyId: fleetCompanyId
    },
    headers: {
      "portal-token": true,
    }
  })
}

/**
 * 尚未支持的 eld 的问题反馈
 * @param {*} data 
 * @returns 
 */
export function feedbackNotIntegration(data) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: "/zuul/questionnaire_info/add",
    method: "post",
    data,
    headers: {
      "portal-token": true,
    }
  })
}

/**
 * 获取logo
 * @returns 
 */
export function getEldIcons() {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: "/zuul/eld-integration/icons",
    method: "get",
    headers: {
      "portal-token": true,
    }
  })
}

/**
 * 获取 To Connect 列表
 * @returns 
 */
export function getToConnect(fleetCompanyId) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/eld-integration/to-connect/driver`,
    method: "get",
    params: {
      fleetCompanyId: fleetCompanyId
    },
    headers: {
      "portal-token": true,
    }
  })
}

/**
 * 匹配 command 和 eld的Driver
 * @param {*} data 
 * @returns 
 */
export function connectWithEld(data) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: "/zuul/eld-integration/connect/driver",
    method: "post",
    headers: {
      "portal-token": true,
    },
    data,
  })
}

/**
 * 获取 connected list
 * @returns 
 */
export function connectedDriver(data) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: "/zuul/eld-integration/connected/driver",
    method: "post",
    headers: {
      "portal-token": true,
    },
    data
  })
}

/**
 * 移除已连接的Driver
 * @param {*} id 
 * @returns 
 */
export function disconnectConnectedDriver(id, fleetCompanyId) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/eld-integration/disconnect/driver/${id}`,
    method: "get",
    params: {
      fleetCompanyId: fleetCompanyId
    },
    headers: {
      "portal-token": true,
    },
  })
}

/**
 * 邀请 eld driver
 * @param {*} data 
 * @returns 
 */
export function inviteDriver(data) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: '/zuul/eld-integration/invite/driver',
    method: "post",
    headers: {
      "portal-token": true,
    },
    data,
  })
}

/**
 * 获取 Truck 的 To Connect 列表
 * @returns 
 */
export function getConnectTruck(fleetCompanyId) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/eld-integration/to-connect/truck`,
    method: "get",
    params: {
      fleetCompanyId: fleetCompanyId
    },
    headers: {
      "portal-token": true,
    },
  })
}

/**
 * 获取 Truck 的 Connected 列表
 * @returns 
 */
export function getConnectedTruck(data) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: '/zuul/eld-integration/connected/truck',
    method: "post",
    headers: {
      "portal-token": true,
    },
    data
  })
}

/**
 * 连接 Truck
 * @param {*} data 
 * @returns 
 */
export function connectWithTruckEld(data) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: '/zuul/eld-integration/connect/truck',
    method: "post",
    headers: {
      "portal-token": true,
    },
    data,
  })
}

/**
 * 断开与 Truck 的连接
 * @param {*} id 
 * @returns 
 */
export function disconnectTruck(id, params = {}) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/eld-integration/disconnect/truck/${id}`,
    method: "get",
    params: params,
    headers: {
      "portal-token": true,
    }
  })
}

/**
 * driver Connected 刷新
 * @returns 
 */
export function driverConnectedRefresh(fleetCompanyId) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/eld-integration/integrationHOSAndLocation`,
    method: "get",
    params: {
      fleetCompanyId: fleetCompanyId
    },
    headers: {
      "portal-token": true,
    }
  });
}

/**
 * truck Connected 刷新
 * @returns 
 */
export function truckConnectedRefresh(id) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/eld-integration/integrationLocation?fleetCompanyId=${id}`,
    method: "get",
    headers: {
      "portal-token": true,
    }
  });
}

export function getCarrierCode(id) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/eld-integration/carrier/code?fleetCompanyId=${id}`,
    method: "get",
    headers: {
      "portal-token": true,
    }
  });
}

export function syncDriverData(id) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/eld-integration/sync-driver-truck/${id}`,
    method: "get",
    headers: {
      "portal-token": true,
    }
  });
}

export function getCarrierList() {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/carrier/get/all/dispatcher/carrier`,
    method: "get",
    headers: {
      "portal-token": true,
    }
  });
}

export function getCarrierEmailList(params) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/eld-integration/remind/email/list`,
    method: "get",
    params: params,
    headers: {
      "portal-token": true,
    }
  });
}

export function remindEmail(data) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/eld-integration/remind`,
    method: "post",
    data: data,
    headers: {
      "portal-token": true,
    }
  });
}

export function getCarrierDriverAvailable(fleetCompanyId) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver/available?fleetCompanyId=${fleetCompanyId}`,
    method: "get",
    headers: {
      "portal-token": true,
    }
  });
}

export function eldTask(data) {
  return request({
    url: `/fleet/eld/task/push?dataTypes=${data.dataType}&companyId=${data.companyId}`,
    method: "get",
    headers: {
      "portal-token": true,
    }
  });
}



